import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent {
  @Input() status:  any = '';
  @Input() showIcon: boolean = true;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  get normalizedStatus(): string {
    const words = (this.status || '').replaceAll('_', ' ').split(' ');
    return words.map((w: any) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
  }

  get iconType(): 'check' | 'dot' | 'warning' | 'clock' {
    const status = this.status?.toUpperCase();
    switch (status) {
      case 'PASS':
      case 'PASSED':
      case 'COMPLETED':
        return 'check';
      case 'EXECUTING':
        return 'dot';
      case 'PENDING':
      case 'WAITING':
      case 'STOPPED':
        return 'clock';
      default:
        return 'warning';
    }
  }

  get statusClass(): string {
    const status = this.status?.toUpperCase();
    switch (status) {
      case 'PASS':
      case 'PASSED':
      case 'COMPLETED':
        return 'status-passed';
      case 'FAIL':
      case 'FAILED':
        return 'status-failed';
      case 'EXECUTING':
        return 'status-executing';
      case 'WAITING':
        return 'status-waiting';
      case 'PENDING':
        return 'status-pending';
      case 'STOPPED':
        return 'status-stopped';
      case 'ABORTED':
        return 'status-aborted';
      case 'EXITED':
        return 'status-exited';
      case 'SKIPPED':
        return 'status-skipped';
      case 'NOT_CREATED':
        return 'status-not-created';
      default:
        return 'status-default';
    }
  }
}
